module.exports = __webpack_public_path__ + "img/waveform-lines.c6c7c22d.svg";